<template>
  <div>
    <div v-if="!this.groupItems">
      <Loader />
    </div>
    <div v-if="this.groupItems">
      <v-col cols="12" v-for="item in this.groupItems" :key="item.id">
        <v-card class="mx-auto">
          <template slot="progress">
            <v-progress-linear
              color="deep-purple"
              height="10"
              indeterminate
            ></v-progress-linear>
          </template>

          <v-img height="250" :src="item.images ? item.images[0] : ''"></v-img>

          <v-card-title> {{ item.itemName }}</v-card-title>

          <v-card-text>
            <v-row align="center" class="mx-0">
              <v-rating
                :value="4.5"
                color="amber"
                dense
                half-increments
                readonly
                size="14"
              ></v-rating>

              <div class="grey--text ms-4">4.5 (413)</div>
            </v-row>

            <div class="my-4 text-subtitle-1">
              {{ item.created_by }} - {{ item.age }}
            </div>
          </v-card-text>

          <v-divider class="mx-4"></v-divider>

          <v-card-title> R{{ item.dailyFee }} per day</v-card-title>

          <!-- <v-card-text>
            <v-chip-group
              v-model="selection"
              active-class="deep-purple accent-4 white--text"
              column
            >
              <v-chip>5:30PM</v-chip>

              <v-chip>7:30PM</v-chip>

              <v-chip>8:00PM</v-chip>

              <v-chip>9:00PM</v-chip>
            </v-chip-group>
          </v-card-text> -->

          <v-card-actions>
            <v-btn color="deep-purple lighten-2" text> Reserve </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from 'firebase/firestore';
export default {
  name: 'StrappGroupItems',

  data() {
    return {
      groupItems: [],
    };
  },

  components: {
    Loader: () => import('@/components/Loader.vue'),
  },

  async created() {
    const db = getFirestore();
    const q = query(
      collection(db, 'items'),
      where('groupIds', 'array-contains', this.$route.params.name)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      console.log(doc.id, ' => ', doc.data());
    });

    this.groupItems = querySnapshot.docs.map((doc) => doc.data());

    //order by createdAt desc
    this.groupItems.sort((a, b) => {
      return b.createdAt - a.createdAt;
    });

    // create a variable called age that uses the createdAt and minus it from the current date to get the age of the item
    this.groupItems.forEach((item) => {
      const timestamp = item.createdAt.toDate();

      // Get the current time as a JavaScript Date object
      const now = new Date();

      // Calculate the difference between the two times in milliseconds
      const age = now.getTime() - timestamp.getTime();

      // Convert the difference to seconds and return it

      console.log('AGE:', age);
      //convert age to user freindly time
      const days = Math.floor(age / (1000 * 60 * 60 * 24));
      const hours = Math.floor(age / (1000 * 60 * 60));
      const minutes = Math.floor(age / (1000 * 60));
      const seconds = Math.floor(age / 1000);

      if (days > 1) {
        item.age = `${days} days ago`;
      } else if (hours > 1) {
        item.age = `${hours} hours ago`;
      } else if (minutes > 1) {
        item.age = `${minutes} minutes ago`;
      } else if (seconds > 1) {
        item.age = `${seconds} seconds ago`;
      } else {
        item.age = `just now`;
      }

      console.log(item.age);
    });
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
